module.exports = __webpack_public_path__ + "img/04.fa446ca6.jpg";